type PublicCallPayload = {
  destination?: string
  label?: string
}

const normalizeDestination = (value: string) => String(value || '')
  .replace(/^tel:/i, '')
  .replace(/[^\d+]/g, '')

export const usePublicCallActions = () => {
  const open = useState<boolean>('public-call:open', () => false)
  const destination = useState<string>('public-call:destination', () => '')
  const label = useState<string>('public-call:label', () => '')

  const openDialog = (payload: PublicCallPayload = {}) => {
    destination.value = normalizeDestination(payload.destination || '')
    label.value = String(payload.label || '').trim()
    open.value = true
  }

  const closeDialog = () => {
    open.value = false
  }

  return { open, destination, label, openDialog, closeDialog }
}
